export default {
  preview: {
    label: 'Anteprima',
    tooltip: 'Visualizza in anteprima la pagina degli ordini online in una nuova scheda.',
  },
  buttons: {
    visit_online_store: 'Shop online',
  },
  toasts: {
    failed_to_launch_orders_portal_app: 'Avvio del portale ordini non riuscito',
  },
};
